module.exports = __webpack_public_path__ + "static/media/president.e50db8a6.jpg";